<!-- /**
 * 基础菜单 商品管理
 */ -->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>首页图片</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入图片名称"></el-input>
      </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small"
    :data="listData"
    highlight-current-row
    v-loading="loading"
    border
    :header-cell-style="{'font-size':'.78125rem','text-align':'center',padding:'0'}"
    :header-row-style="{height: '3rem'}"
    :cell-style="{'text-align':'center',padding: '0'}"
    element-loading-text="拼命加载中"
    style="width: 100%;">
      <el-table-column prop="imageName" label="图片名称">
      </el-table-column>
      <el-table-column prop="imageType" label="图片类型">
        <template slot-scope="scope">
          <div>{{getImgTypeKey(scope.row.imageType) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="展示顺序">
        <template slot-scope="scope">
          <div>{{scope.row.order|| '— —'}}</div>
        </template>
      </el-table-column>
      <el-table-column label="跳转链接类型">
        <template slot-scope="scope">
            {{pathType(scope.row.skipInOut)}}
        </template>
      </el-table-column>

      <el-table-column prop="createDate" label="添加时间">
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="更新时间">
        <template slot-scope="scope">
          <div>{{scope.row.updateDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="使用状态">
        <template slot-scope="scope">
          <el-switch
          v-model="scope.row.state"
          :active-value="0"   :inactive-value="1"
          active-text="启用" inactive-text="禁用"
          @change="editType($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="imageUrl" label="缩略图" width="200">
        <template class="imgarea" slot-scope="scope">
            <el-image
                style="width: 80px; height: 50px"
                :src=scope.row.imageUrl
                :preview-src-list=[scope.row.imageUrl]>
            </el-image>
            <!-- <span>点击预览</span> -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="updateTime(scope.$index, scope.row)">设为最新</el-button> -->
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.imageType !== 444 && scope.row.imageType !== 445" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div id="printcontent" ref='printcontent'>
      <img :src="item.src" class="print_img" v-for="item in multipleSelection" :key='item.id' />
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @close="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="图片名称" prop="imageName">
          <el-input size="small" v-model.trim="editForm.imageName" auto-complete="off" placeholder="请输入图片名称"></el-input>
        </el-form-item>
        <el-form-item label="图片类型" prop="imageType">
          <el-select v-model="editForm.imageType" clearable
              filterable placeholder="请选择">
            <el-option
              v-for="item in imgtypeOptions"
              :key="Math.random(item.id)"
              :label="item.key"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示顺序" prop="order" v-if="editForm.imageType == '11'">
          <el-input-number v-model="editForm.order" :min="1" :max="4"></el-input-number>
        </el-form-item>
        <el-form-item label="跳转链接类型" prop="skipInOut">
          <el-select v-model="editForm.skipInOut" clearable
                     filterable placeholder="请选择">
            <el-option
              v-for="item in inskipInOutOptions"
              :key="item.id"
              :label="item.key"
              :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接" prop="url">
          <el-input  size="small" v-model="editForm.url" :placeholder="urlPlaceholder">
            <template v-if="editForm.skipInOut == 1" slot="prepend">Https://</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="editForm.skipInOut == 2" label="小程序appId" prop="appId">
          <el-input  size="small" v-model="editForm.appId" placeholder="请输入第三方小程序appId"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-switch v-model="editForm.state"
          active-text="启用"
          inactive-text="禁用"
          :active-value='0'
          :inactive-value='1'>
          </el-switch>
        </el-form-item>
        <el-form-item label="上传图片" prop="imageUrl">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :http-request="upImgRequest"
            :before-upload="beforeAvatarUpload">
            <img v-if="editForm.imageUrl" :src="editForm.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="img_size_tip">避免影响小程序内显示效果，首页轮播图请上传：{{editForm.imageType == 444? '750px/480px':'750px/720px'}}大小或等比例图片</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptDelete,upimg ,addImgForm,indexImgList,delImgForm,updateImgForm,imgLock} from '../../api/userMG'
import { getDictByTypeId} from '@/api/system'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      showOutLinkInput:false, //外部链接
      title: '添加',
      formData:null,
      imgtypeOptions:[],
      imgtypeOptions1:[],
      multipleSelection:[],
      appLinkOptions:[],//小程序跳转链接
      editForm: {
        imageName: '',
        imageType: '',
        imageNo: '',  //后端返回的图片uuid
        url:'',
        order:0,
        state:0,
        imageUrl:'',
        skipInOut:0,
      },
      // rules表单验证
      rules: {
        imageName: [
          { required: true, message: '请输入图片名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        imageType: [
          { required: true, message: '请输入图片类型', trigger: 'blur' },
        ],
        skipInOut: [
          { required: true, message: '请选择跳转类型', trigger: 'change' },
        ],
        url: [
          { required: true, message: '请输入跳转链接', trigger: 'change' },
        ],
        imageUrl: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],

      },
      formInline: {
        page: 1,
        limit: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      inskipInOutOptions:[
        {
          key:'小程序内部页面',
          val:0,
          id:1
        },
        {
          key:'小程序访问web页面',
          val:1,
          id:2
        },
        {
          key:'第三方小程序跳转',
          val:2,
          id:3
        },
      ],
      urlPlaceholder:'请输入小程序页面地址，如：pages/details/details?id=6204'
    }
  },
  computed:{
    //该计算属性返回要监视的对象属性值
    formSkipInOut(){
      return this.editForm.skipInOut;
    }
  },
  watch:{
    formSkipInOut: function(newVal, oldVal){
      if(newVal == 0){
        this.urlPlaceholder = '请输入小程序页面地址，如：pages/details/details?id=6204'
      }
      else if(newVal == 1) {
        this.urlPlaceholder = '请输入web页面地址'
      }
      else  if(newVal == 2){
        this.urlPlaceholder = '请输入小程序页面地址，如：pages/details/details?id=6204'
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getPicType()
  },
  methods: {
// 根据字典值获取字典key
    getImgTypeKey(v){
      let key = ''
        this.imgtypeOptions1.forEach(item=>{
          if(item.id == v){
            key= item.key
          }
        })
        return key
    },
    // 获取图片类型列表
    getPicType(){
      getDictByTypeId(7).then(res=>{
        this.imgtypeOptions = res.body.filter(item => item.id !== 444 && item.id !== 445)
        this.imgtypeOptions1 = res.body
      })
    },
    // 获取小程序链接类型列表
    getAppLink(){
      getDictByTypeId(9).then(res=>{
        this.appLinkOptions = res.body
      })
    },
    // 自定义上传方法
    upImgRequest(filePath){
          let formData = new FormData()
            formData.append('file',filePath.file)
          upimg(formData).then(res=>{
            this.editForm.imageUrl = res.body.ossUrl
            this.editForm.imageNo = res.body.imageNo
          })
      },
      beforeAvatarUpload(file) {
        // console.log(file,'图片文件before');
        const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
        // return isLt2M;
      },
     // 将图片设置为最新
     updateTime(){
        this.$confirm('设为最新将替换正在使用的图片，您确定设置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(()=>{
          // 走一遍编辑接口
        })
      },
    // 获取列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      indexImgList(parameter)
        .then(res => {
          this.loading = false
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.body.records
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.body.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 修改type
    editType: function(event, row) {
      this.loading = true
      let parm = {
        state: event,
        id: row.id,
      }
      // 修改状态
      imgLock(parm).then(res => {
        this.loading = false
        if (res.rsp_code !== 200) {
          this.$message({
            type: 'info',
            message: res.rsp_msg
          })
        } else {
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.getdata(this.formInline)
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      console.log(parm,this.formInline);
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    reset(){
      this.editForm={
        imageName: '',
        imageType: '',
        imageNo: '',  //后端返回的图片uuid
        url:'',
        order:0,
        state:0,
        imageUrl:'',
        skipInOut:0,
      }
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      // this.getAppLink()
      console.log(1111)
      // this.reset()
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改';
        this.editForm = {...row}
        this.editForm.url = row.url
        this.editForm.createDate=new Date(row.createDate)
        this.editForm.updateDate=new Date(row.updateDate)
      } else {
        this.title = '添加'
        this.editForm.skipInOut = 0
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        let subType = this.title=='修改'?updateImgForm:addImgForm;
        if (valid) {
          console.log(this.editForm)
          subType(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.rsp_code==200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delImgForm({id:row.id})
            .then(res => {
              if (res.rsp_code == 200) {
                this.$message({
                  type: 'success',
                  message: '图片已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('图片删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.reset()
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    pathType(v) {
      for (let item of this.inskipInOutOptions) {
        if (item.val == v) {
          return item.key
        }
      }
      return "未知";
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<style scoped>

.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/img/IndexSwiper.vue